import { requestTimeout } from './utlities';
export default class Cookie {
  banner;
  reloadOnAccept;

  constructor(selector, reloadOnAccept = true) {
    this.banner = document.querySelector(selector);
    this.reloadOnAccept = reloadOnAccept;
    if (this.banner) {
      if (!this.hasCookie()) {
        this.initBanner();
      } else {
        this.banner.remove();
      }
    }

  }

  initBanner() {
    this.banner.classList.add('show');
    this.acceptBtn = document.getElementById('acceptCookies');
    if (this.acceptBtn) {
      this.acceptBtn.addEventListener('click', () => this.dismiss('true'))
    }
    this.declineBtn = document.getElementById('declineCookies');
    if (this.declineBtn) {
      this.declineBtn.addEventListener('click', () => this.dismiss('false'))
    }
    this.dismissBtn = document.getElementById('dismissCookies');
    if (this.dismissBtn) {
      this.dismissBtn.addEventListener('click', () => this.dismiss())
    }
  }

  dismiss(acceptanceStatus = false) {
    this.banner.classList.remove('show');
    if (acceptanceStatus) {
      if (acceptanceStatus === 'true') {
        this.setCookie('cookiesaccepted', 'true', 30);
        if (this.reloadOnAccept) {
          window.location.reload();
        }
      } else {
        this.setCookie('cookiesaccepted', 'false', 30);
      }
    }
    requestTimeout(() => {
      this.banner.remove();
    }, 300)
  }

  acceptedCookie() {
    return this.getCookie('cookiesaccepted') === 'true';
  }

  declinedCookie() {
    return this.getCookie('cookiesaccepted') === 'false';
  }

  hasCookie() {
    return this.getCookie('cookiesaccepted') !== '';
  }

  getCookie(cname) {
    var name = cname + '=';
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }

  setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = 'expires=' + d.toUTCString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
  }
}
